import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import StudentDiscountsComp from './StudentDiscountsComp';

function StudentDiscounts() {
  return (
    <div className='mainContainer'>
      <LeftBar />
      <div className='theMainContainer'>
        <Dashnav />
        <StudentDiscountsComp />
      </div>
    </div>
  );
}

export default StudentDiscounts;
